var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"cb-title-model-a"},[_c('v-icon',{staticClass:"cb-icon"},[_vm._v(_vm._s(_vm.icon))]),_c('v-col',[_c('span',{staticClass:"cb-title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._t("save")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }